import Vue from "components/base";
import { Component } from "vue-property-decorator";
import template from "./NavBar.vue";

@Component({
  name: "NavBar",
  mixins: [template],
  components: {}
})
export default class NavBar extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/NavBar/NavBar.ts